import { render } from "./SettingsModal.vue?vue&type=template&id=7e614bf4&scoped=true&ts=true"
import script from "./SettingsModal.vue?vue&type=script&lang=ts"
export * from "./SettingsModal.vue?vue&type=script&lang=ts"

import "./SettingsModal.vue?vue&type=style&index=0&id=7e614bf4&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e614bf4"]])

export default __exports__